import { useLoaderData } from "react-router-dom";

import Modal from "../../../../../global/Modal";
import DETAIL_TEMPLATE from "../../config/detail.template";
import useOnClickEventListener from "../../hooks/useOnClickEventListener";
import { useViewDetailStore } from "../../store/viewDetailStore";
import ActionButtons from "../buttons/ActionButtons";

import EditField from "./EditField";

export default function EditModal({ openModal, handleCloseModal }) {
  const { viewName } = useLoaderData();
  const { initialViewDetail, modifiedViewDetail, enableSaveBtn, enableCancelBtn } =
    useViewDetailStore();
  const { handleOnClickSaveButton, handleOnClickCancelButton, handleOnChangeFieldValue } =
    useOnClickEventListener();
  const fields = DETAIL_TEMPLATE[viewName]?.editMode ?? [];

  return (
    <Modal open={openModal} onClose={handleCloseModal} maxWidth="md">
      <div className="h-full w-full p-6">
        {fields &&
          fields.map((row, rowIndex) => (
            <div key={`row-${rowIndex}`} className="flex w-full flex-col gap-2">
              {
                <div className="flex flex-row justify-between gap-2 p-1">
                  {row.map((col, colIndex) => {
                    const width = col.width || 100 / row.length;
                    const style = { width: `${width}%` };
                    return (
                      <div key={`${rowIndex}-${colIndex}`} style={style}>
                        <EditField
                          field={col}
                          data={modifiedViewDetail ?? initialViewDetail}
                          customOnChange={handleOnChangeFieldValue}
                        />
                      </div>
                    );
                  })}
                </div>
              }
            </div>
          ))}
      </div>
      <ActionButtons
        disableCancel={!enableCancelBtn}
        disableSave={!enableSaveBtn}
        handleOnClickSaveButton={handleOnClickSaveButton}
        handleOnClickCancelBtn={handleOnClickCancelButton}
      />
    </Modal>
  );
}
